import Axios from "axios";
import get from "lodash/get";
import { load } from "redux-localstorage-simple";
import { useLocation } from "react-router-dom";

const API_ROOT = process.env.REACT_APP_API_ENDPOINT;
let useSessionSet = false;
const initUserSession = () => {
  const userSession = get(load({ states: ["user"] }), [
    "user",
    "data",
    "session",
  ]);
  if (userSession) {
    useSessionSet = true;
    Axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${userSession["access-token"]}`;
    Axios.defaults.headers.common["access-token"] = userSession["access-token"];
    Axios.defaults.headers.common["client"] = userSession["client"];
    Axios.defaults.headers.common["token-type"] = userSession["token-type"];
    Axios.defaults.headers.common["uid"] = userSession["uid"];
  }
};
initUserSession();

const handleError = (err) => {
  const errorMessage =
    get(err, ["response", "data", "errors", 0]) ||
    get(err, ["response", "data", "message"]) ||
    err.message ||
    "An unexpected error occurred";

  console.error("API Error:", errorMessage);
  return Promise.reject(errorMessage);
};

const handleResponse = (res, fallback) => {
  const { status, data, message } = res.data;

  if (status === "success") {
    return data || fallback;
  }

  if (status === "error") {
    return handleError({
      response: { data: { errors: [message || "An error occurred"] } },
    });
  }

  return data || fallback;
};

export const SERVER_HOST = process.env.REACT_APP_API_BASE_ENDPOINT;

export const getApi = async (url, params = {}, fallback = {}) => {
  if (!useSessionSet) {
    initUserSession();
  }
  try {
    const res = await Axios.get(`${API_ROOT}/${url}.json`, { params });
    return handleResponse(res, fallback);
  } catch (err) {
    return handleError(err);
  }
};

export const getApiResponse = (url, params = {}, fallback = {}) => {
  if (!useSessionSet) {
    initUserSession();
  }
  return Axios.get(`${API_ROOT}/${url}.json`, { params }).then((res) => {
    return get(res, ["data"], fallback);
  });
};

export const postApi = async (url, params = {}, fallback = {}) => {
  if (!useSessionSet) {
    initUserSession();
  }
  try {
    const res = await Axios.post(`${API_ROOT}/${url}.json`, params);
    return handleResponse(res, fallback);
  } catch (err) {
    return handleError(err);
  }
};

export const updateApi = async (url, params = {}, fallback = {}) => {
  if (!useSessionSet) {
    initUserSession();
  }
  try {
    const res = await Axios.put(`${API_ROOT}/${url}.json`, params);
    return handleResponse(res, fallback);
  } catch (err) {
    return handleError(err);
  }
};

export const postApiClean = async (url, params = {}) => {
  if (!useSessionSet) {
    initUserSession();
  }
  try {
    const res = await Axios.post(`${API_ROOT}/${url}.json`, params);
    return res;
  } catch (err) {
    return handleError(err);
  }
};

Axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 429) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      return Axios(error.config);
    }
    return handleError(error);
  }
);

export const useQuery = (queryParam) => {
  const search = new URLSearchParams(useLocation().search);
  return search.get(queryParam);
};
